import React from "react";
import Link from "gatsby-link";
import Icon from "../Icon";
import { ButtonTextNoLink } from "../Buttons";
import { endSlash } from "../../util/helperFunctions";

// Builds Explore Downtown, Live Downtown, etc colored blocks
const StatQuery = ({ page, className, direction }) => {
  // page and direction are required
  // className can be used for background color and spacing
  const titleParts = page.title.split(" ");
  return (
    <Link
      to={endSlash(page.route)}
      className={`stat-query ${className} flex justify-center-l db w-100 white flex flex-column justify-between relative`}
    >
      <div className="stat-query__inner flex flex-column justify-between h-100 relative w-100">
        <h5 className="h-4 h-3--l ttu mb0 tc-l">
          {titleParts[0]}
          <br />
          {titleParts[1]}
        </h5>
        <div className="stat-query__illustration">
          <Icon path={`illi-${titleParts[0].toLowerCase()}`} className="flex" />
        </div>
        <p className="dn db-l p mb0 tc mb3-l">{page.abstract}</p>
        <ButtonTextNoLink className="dn db-l white" />
        <Icon path="arrow-right" height="18" width="32" className="flex" />
      </div>
    </Link>
  );
};

export default StatQuery;



// WEBPACK FOOTER //
// ./src/components/HomeHelpers/StatQuery.js